import React from 'react';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';
import { MissedDiscountReasons } from 'subscriptionOptions/multiSubjectDiscount';

type Props = {
  reasons: MissedDiscountReasons;
  onClose: () => void;
};

const SELECTION_REASON = "the package type or subscription length doesn't match across both subscriptions";
const AUTO_RENEW_REASON = 'auto-renew is switched on for one and off for the other';

const reasonText = (reasons: MissedDiscountReasons): string => {
  if (reasons.selection && reasons.autoRenew) {
    return SELECTION_REASON + ', and ' + AUTO_RENEW_REASON + '.';
  }

  return reasons.selection ? SELECTION_REASON + '.' : AUTO_RENEW_REASON + ', so they are paid for separately.';
};

export const RenewalDiscountLostModal: React.FC<Props> = ({ reasons, onClose }) => {
  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={true}
      hdrTitle={'Multi-subject discount'}
      position="right"
      givenClass="RenewalDiscountLostModal"
      noFooter={true}
      handleClose={onClose}
      width={560}
    >
      <p>
        {reasons.selection ? 'Your current selections' : 'Your subscriptions'} no longer qualify for the{' '}
        <strong>10% multi-subject discount</strong> because {reasonText(reasons)}
      </p>
      <button type="button" className="Btn BtnOrange" onClick={onClose}>
        Ok
      </button>
    </PopupOrPanel>
  );
};
